import { SVGProps, useId } from "react";

export default function MoneyReceiveIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, stroke = "#E3592E", ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.17999 10.16 8.48999 10.96 8.48999H12.84C13.76 8.48999 14.51 9.26999 14.51 10.24"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 7.5V16.5V7.5Z" fill={`url(#paint0_${id})`} />
      <path
        d="M12 7.5V16.5"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2"
        stroke={`url(#paint1_${id})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6V2H18"
        stroke={`url(#paint2_${id})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7L22 2"
        stroke={`url(#paint3_${id})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="12.5"
          y1="7.5"
          x2="12.5"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="12"
          y1="2"
          x2="12"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="20"
          y1="2"
          x2="20"
          y2="6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint3_${id}`}
          x1="19.5"
          y1="2"
          x2="19.5"
          y2="7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
